import { gql } from '@apollo/client';
import { ORDER_ETA_FRAGMENT } from '@/components/orders/order-eta-banner';
import { ORDER_FULFILLMENT_DATE_FRAGMENT } from '@/components/orders/order-fulfillment-date';
import {
  ORDER_INVOICE_CHECK_IN_FIELDS_FRAGMENT,
  ORDER_INVOICE_LINE_ITEM_FRAGMENT,
  ORDER_INVOICE_PARTIAL_PAYMENT_FRAGMENT,
  ORDER_PLACEMENT_FIELDS_FRAGMENT,
} from '@/components/orders/hooks/use-get-order';

export const GET_INVOICE_DETAIL_QUERY = gql`
  fragment OrderInvoiceOrderFields on orders {
    ...OrderETAFields
    ...OrderFulfillmentDateFields
    customer_facing_id
    fulfillment_type
    placed_at
    placed_by {
      name
      supplier_employee_overrides(
        where: {
          supplier: { supplier_order_invoices: { uuid: { _eq: $invoiceUUID } } }
        }
      ) {
        name
        uuid
      }
      uuid
    }
    uuid
  }

  query Invoice_GetInvoiceById($invoiceUUID: uuid!) {
    getOrderInvoiceById(order_invoice_id: $invoiceUUID) {
      order_invoice {
        chat_uuid
        document_url
        due_at
        erp_balance_in_micros
        invoice_date
        invoice_number
        order_invoice_check_in {
          ...OrderInvoiceCheckInFields
        }
        order_invoice_line_items {
          ...OrderInvoiceLineItemFields
          variant_pack_uuid
        }
        order_invoice_status {
          balance_in_micros
          use_pepper_balance
          uuid
        }
        ...OrderInvoicePartialPaymentFields
        seen
        uuid
      }
      order {
        ...OrderInvoiceOrderFields
      }
      public_url
      translated_order_fulfillment_display_name
    }
  }

  ${ORDER_ETA_FRAGMENT}
  ${ORDER_FULFILLMENT_DATE_FRAGMENT}
  ${ORDER_INVOICE_CHECK_IN_FIELDS_FRAGMENT}
  ${ORDER_PLACEMENT_FIELDS_FRAGMENT}
  ${ORDER_INVOICE_LINE_ITEM_FRAGMENT}
  ${ORDER_INVOICE_PARTIAL_PAYMENT_FRAGMENT}
`;
